/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import ChatListNewActivityItem from 'chat/components/ChatListNewActivityItem.jsx';

type State = {
  canCollectMoney: boolean
};

type Props = {
  onClick?: () => void,
};

class ChatListNewActivityItemContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState() {
    const user = CurrentUser.isSignedIn() && CurrentUser.getUser();

    return {
      canCollectMoney: user && user.canCollectMoney(),
    };
  }

  render() {
    return (
      <ChatListNewActivityItem
        onClick={this.props.onClick}
        canCollectMoney={this.state.canCollectMoney}
      />
    );
  }
}

export default Container.create(ChatListNewActivityItemContainer, { withProps: true });



// WEBPACK FOOTER //
// ./src/chat/containers/ChatListNewActivityItemContainer.jsx